import _ from 'lodash';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './reducers';
import { ConfigProvider } from 'antd';
import zhTW from 'antd/lib/locale-provider/zh_TW';
import WJSON from 'libs/wjson';
import App from './routes/App';
import Login from './routes/Login';
import ECLogin from './routes/ECLogin';
import AppHelper from 'libs/AppHelper';
import { wConnectRedux } from 'reducers';
import { StoreListEditor } from 'blocks/stores/store-list-v2';
import { StoreMapEditor } from 'blocks/stores/store-map';
import { BrandListEditor } from 'blocks/brands/brand-list';
import { UserLoginEditor } from 'blocks/users/user-sso-login';
import { UserLoginCCEditor } from 'blocks/users/user-sso-login-cc';
import { UserProfileEditor } from 'blocks/users/user-profile';
import { UserProfileCCEditor } from 'blocks/users/user-profile-cc';
import { UserPasswordEditor } from 'blocks/users/user-password';
import { UserPasswordCCEditor } from 'blocks/users/user-password-cc';
import { UserPaymentEditor } from 'blocks/users/user-payment';
import { UserPointEditor } from 'blocks/users/user-point';
import { UserInvoiceEditor } from 'blocks/users/user-invoice';
import { UserInvoiceCarrierConsolidationEditor } from 'blocks/users/user-invoice-carrier-consolidation';
import { UserConnectEditor } from 'blocks/users/user-connect';
import { UserBigPlatformProcessEditor } from 'blocks/users/user-big-platform-process';
import { UserCarrierBindingEditor } from 'blocks/users/user-carrier-binding';
import { CatalogueListEditor } from 'blocks/catalogues/catalogue-list';
import { RecruitEditor } from 'blocks/cibc/cibc-recruit';
import { FAQUsEditor } from 'blocks/customer-service/faq-us';
import { CIBCInfoEditor } from 'blocks/cibc/cibc-contact-us';
import { CIBCServicePointEditor } from 'blocks/cibc/cibc-servicepoint';
import { FeedBackEditor } from 'blocks/customer-service/feedback';
import { StockListEditor } from 'blocks/stock/stock-list.js';
import { StockAllEditor } from './blocks/stock/stock-all.js';

// 引入模組-blocks
import registerVulcanBlockType, { getBlockMountIdByName } from './blocks';

AppHelper.updateConfig();

const renderReactDOM = (id, MixNode) => {
  // className for blocks
  const mountPoints = [...document.getElementsByClassName(`wp-block-${id}`)];
  // id for 後台管理
  const mountPoint = document.getElementById(id);
  if (mountPoint && _.indexOf(mountPoints, mountPoint) === -1) {
    mountPoints.push(mountPoint);
  }
  // console.log(`renderReactDOM`, id, `wp-block-${id}`, mountPoint, mountPoints)

  if (mountPoints.length === 0) return;

  _.map(mountPoints, (node) => {
    const attributes = WJSON.decode(node.getAttribute('vu-attributes'));
    // console.log('renderReactDOM', attributes, node)
    ReactDOM.render(
      <Provider store={store}>
        <ConfigProvider locale={zhTW}>
          <MixNode {...attributes} />
        </ConfigProvider>
      </Provider>,
      node
    );
  });
};

// 掛載ReactComponent
renderReactDOM('loginButton', Login);
renderReactDOM('ECLogin', ECLogin);
// 管理頁面
renderReactDOM('cec-mount-point', App);
// Blocks 頁面編輯器 & 前端
const blocksSetting = [
  {
    module: 'stock',
    name: 'stock-all',
    title: '全台總庫存數量',
    icon: 'megaphone',
    editor: StockAllEditor,
    keywords: ['全台庫存', 'stock'],
    attributes: {
      productId: { type: 'int' },
    },
  },
  {
    module: 'stock',
    name: 'stock-list',
    title: '庫存列表',
    icon: 'megaphone',
    editor: StockListEditor,
    keywords: ['庫存', 'stock'],
    attributes: {
      productId: { type: 'int' },
      productName: { type: 'string' },
    },
  },
  {
    module: 'stock',
    name: 'stock-store',
    title: '門市選擇器',
    icon: 'store',
    keywords: ['庫存', 'stock'],
  },
  {
    module: 'news',
    name: 'news-list',
    title: '消息列表',
    icon: 'megaphone',
    keywords: ['消息', 'news'],
    attributes: {
      mode: { type: 'int', default: 1 },
      category_ids: { type: 'array', default: [] },
    },
  },
  {
    module: 'news',
    name: 'news-list-preview',
    title: '預覽消息列表',
    icon: 'megaphone',
    keywords: ['消息', 'news'],
    attributes: {
      mode: { type: 'int', default: 1 },
      category_ids: { type: 'array', default: [] },
    },
  },
  {
    module: 'news',
    name: 'news-info',
    title: '消息資訊',
    icon: 'megaphone',
    keywords: ['消息', 'news'],
  },
  {
    module: 'stores',
    name: 'store-map',
    title: '分店地圖',
    icon: 'admin-site-alt3',
    editor: StoreMapEditor,
    keywords: ['分店', 'store', '地圖', 'map'],
  },
  {
    module: 'stores',
    name: 'store-list',
    title: '分店列表',
    icon: 'store',
    editor: StoreListEditor,
    keywords: ['分店', 'store'],
  },
  {
    module: 'stores',
    name: 'store-info',
    title: '分店資訊',
    icon: 'tagcloud',
    keywords: ['分店', 'store'],
  },
  {
    module: 'stores',
    name: 'store-vendor',
    title: '分店第三方平台列表',
    icon: 'tagcloud',
    keywords: ['第三方平台', 'store'],
  },
  {
    module: 'brands',
    name: 'brand-list',
    title: '品牌列表',
    icon: 'layout',
    editor: BrandListEditor,
    keywords: ['品牌', 'brand'],
  },
  {
    module: 'brands',
    name: 'brand-info',
    title: '品牌資訊',
    icon: 'layout',
    keywords: ['品牌', 'brand'],
  },
  {
    module: 'users',
    name: 'user-sso-login',
    title: '會員登入',
    icon: 'admin-users',
    editor: UserLoginEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-profile',
    title: '會員資料',
    icon: 'edit',
    editor: UserProfileEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-loyaltyprofile',
    title: '好康卡會員資料',
    icon: 'edit',
    editor: UserProfileEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-password',
    title: '密碼變更',
    icon: 'admin-site',
    editor: UserPasswordEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-payment',
    title: '我的消費紀錄',
    icon: 'admin-site',
    editor: UserPaymentEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-point',
    title: '點數紀錄',
    icon: 'admin-site',
    editor: UserPointEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-invoice',
    title: '電子發票',
    icon: 'admin-site',
    editor: UserInvoiceEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-connect',
    title: '關連帳號',
    icon: 'admin-site',
    editor: UserConnectEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-sso-login-cc',
    title: 'CC會員登入',
    icon: 'admin-users',
    editor: UserLoginCCEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-sso-login-oca',
    title: 'OCA會員登入',
    icon: 'admin-users',
    editor: UserLoginEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-profile-oca',
    title: 'OCA會員資料',
    icon: 'edit',
    editor: UserProfileEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-profile-cc',
    title: 'CC會員資料',
    icon: 'edit',
    editor: UserProfileCCEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-password-oca',
    title: 'OCA密碼變更',
    icon: 'admin-site',
    editor: UserPasswordEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-password-cc',
    title: 'CC密碼變更',
    icon: 'admin-site',
    editor: UserPasswordCCEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-payment-oca',
    title: 'OCA我的消費紀錄',
    icon: 'admin-site',
    editor: UserPaymentEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-invoice-carrier-consolidation',
    title: 'OCA發票歸戶',
    icon: 'admin-site',
    editor: UserInvoiceCarrierConsolidationEditor,
    keywords: ['會員', 'user'],
  },
  {
    module: 'users',
    name: 'user-big-platform-process',
    title: '大平台載具歸戶-處理頁面',
    icon: 'admin-site',
    editor: UserBigPlatformProcessEditor,
    keywords: ['會員', 'user', '大平台', '載具', '歸戶'],
  },
  {
    module: 'users',
    name: 'user-carrier-binding',
    title: '大平台載具綁定頁面',
    icon: 'admin-site',
    editor: UserCarrierBindingEditor,
    keywords: ['會員', 'user', '大平台', '載具', '綁定'],
  },
  {
    module: 'catalogues',
    name: 'catalogue-list',
    title: '促銷目錄列表',
    icon: 'book',
    editor: CatalogueListEditor,
    keywords: ['目錄', 'catalogue'],
    attributes: { category_ids: { type: 'array', default: [] } },
  },
  {
    module: 'catalogues',
    name: 'catalogue-pos',
    title: '促銷目錄POS',
    icon: 'book',
    editor: CatalogueListEditor,
    keywords: ['目錄', 'catalogue'],
    attributes: { category_ids: { type: 'array', default: [] } },
  },
  {
    module: 'catalogues',
    name: 'catalogue-info',
    title: '促銷目錄內容',
    icon: 'book',
    keywords: ['目錄', 'catalogue'],
  },
  {
    module: 'widget',
    name: 'widget-weather',
    title: '天氣',
    icon: 'admin-generic',
    keywords: ['天氣', 'weather'],
  },
  {
    module: 'widget',
    name: 'widget-facebook',
    title: 'SocialMedia',
    icon: 'admin-generic',
    keywords: ['facebook'],
  },
  {
    module: 'widget',
    name: 'widget-facebook-mall',
    title: 'MallSocialMedia',
    icon: 'admin-generic',
    keywords: ['facebookmall'],
  },
  {
    module: 'widget',
    name: 'widget-wine',
    title: '酒標',
    icon: 'admin-generic',
    keywords: ['酒標', 'wine'],
  },
  {
    module: 'repair',
    name: 'repair-info',
    title: '家電維修',
    icon: 'layout',
    keywords: ['維修', 'repair'],
  },
  {
    module: 'customer-service',
    name: 'contact-us',
    title: '聯絡我們',
    icon: 'format-status',
    keywords: ['聯絡我們', 'contact'],
  },
  {
    module: 'customer-service',
    name: 'service-us',
    title: '服務',
    icon: 'format-status',
    keywords: ['服務', 'service'],
  },
  {
    module: 'customer-service',
    name: 'faq-us',
    title: '常見問題',
    icon: 'format-status',
    editor: FAQUsEditor,
    keywords: ['常見問題', 'faq'],
  },
  {
    module: 'customer-service',
    name: 'feedback',
    title: '滿意度調查',
    icon: 'format-status',
    editor: FeedBackEditor,
    keywords: ['滿意度調查', 'feedback'],
  },
  {
    module: 'recipes',
    name: 'recipe-list',
    title: '食譜列表',
    icon: 'book',
    editor: BrandListEditor,
    keywords: ['食譜', 'recipe'],
  },
  {
    module: 'recipes',
    name: 'recipe-info',
    title: '食譜資訊',
    icon: 'book',
    keywords: ['食譜', 'recipe'],
  },
  {
    module: 'cibc',
    name: 'cibc-recruit',
    title: '保經人才招募',
    icon: 'book',
    editor: RecruitEditor,
    keywords: ['保經人才招募', 'cibc'],
  },
  {
    module: 'cibc',
    name: 'cibc-servicepoint',
    title: '保經服務據點',
    icon: 'book',
    editor: CIBCServicePointEditor,
    keywords: ['保經服務據點', 'cibc'],
  },
  {
    module: 'cibc',
    name: 'cibc-calculation',
    title: '保障試算',
    icon: 'book',
    keywords: ['保障試算', 'cibc'],
  },
  {
    module: 'cibc',
    name: 'cibc-contact-us',
    title: '保經聯絡我們',
    icon: 'book',
    editor: CIBCInfoEditor,
    keywords: ['保經聯絡我們', 'cibc'],
  },
]

registerVulcanBlockType(blocksSetting);
blocksSetting.forEach((item) => {
  if (_.isBoolean(item.mountView) && item.mountView === false) return;
  renderReactDOM(
    getBlockMountIdByName(item.name),
    wConnectRedux(require(`./blocks/${item.module}/${item.name}`).default)
  );
});



// WEBPACK FOOTER //
// ./src/index.js